import { MapMarkerDistanceIcon } from './MapMarkerDistanceIcon';

/**
 * author: Michael Richins
 * id B2FF0F5A-4B2C-480C-9022-D84AD78E72ED
 * name map-marker-distance
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-distance.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationDistanceIcon = MapMarkerDistanceIcon;
export default LocationDistanceIcon